import { deleteDataAsync, getDataAsync, postDataAsync, putDataAsync } from "../ZeosApiExecutor";
import {
  IAdminCustomerResponse,
  IAdminCustomerSettingsRequest,
  IAdminCustomerSettingsResponse,
  IAdminPropertySettingsRequest,
  IAdminPropertySettingsResponse,
  IAdminUserCreateRequest,
  IAdminUserResponse,
  IAdminUserSuperAdminRequest,
  ISuperAdminOptInRequest,
  ISuperAdminOptInResponse,
} from "../contracts/Admin";
import { IAdmin } from "./interfaces/IAdmin";

const adminPrefix = "/Admin";

export const Admin: IAdmin = {
  getUsersAsync: async () => {
    const response = await getDataAsync<IAdminUserResponse[]>(`${adminPrefix}/Users`, "");
    return response;
  },
  createUserAsync: async (request: IAdminUserCreateRequest) => {
    const response = await postDataAsync<IAdminUserResponse>(`${adminPrefix}/Users`, request);
    return response;
  },
  deleteUserAsync: async (userId: number) => {
    const response = await deleteDataAsync<boolean>(`${adminPrefix}/Users/${userId}`, null);
    return response;
  },
  setSuperAdminAsync: async (zeosUserId: number, request: IAdminUserSuperAdminRequest) => {
    const response = await putDataAsync<IAdminUserResponse>(
      `${adminPrefix}/Users/${zeosUserId}/super-admin`,
      request
    );
    return response;
  },
  getCustomersAsync: async () => {
    const response = await getDataAsync<IAdminCustomerResponse[]>(
      `${adminPrefix}/Reference/Customers`,
      ""
    );
    return response;
  },
  getCustomerSettingsAsync: async (customerId: number) => {
    const response = await getDataAsync<IAdminCustomerSettingsResponse>(
      `${adminPrefix}/CustomerSettings/${customerId}`,
      ""
    );
    return response;
  },
  upsertCustomerSettingsAsync: async (customerId: number, request: IAdminCustomerSettingsRequest) => {
    const response = await putDataAsync<IAdminCustomerSettingsResponse>(
      `${adminPrefix}/CustomerSettings/${customerId}`,
      request
    );
    return response;
  },
  deleteCustomerSettingAsync: async (customerId: number, settingKey: string) => {
    const response = await deleteDataAsync<boolean>(
      `${adminPrefix}/CustomerSettings/${customerId}?key=${encodeURIComponent(settingKey)}`,
      null
    );
    return response;
  },
  getPropertySettingsAsync: async (propertyId: number) => {
    const response = await getDataAsync<IAdminPropertySettingsResponse>(
      `${adminPrefix}/PropertySettings/${propertyId}`,
      ""
    );
    return response;
  },
  upsertPropertySettingsAsync: async (propertyId: number, request: IAdminPropertySettingsRequest) => {
    const response = await putDataAsync<IAdminPropertySettingsResponse>(
      `${adminPrefix}/PropertySettings/${propertyId}`,
      request
    );
    return response;
  },
  deletePropertySettingAsync: async (propertyId: number, settingKey: string) => {
    const response = await deleteDataAsync<boolean>(
      `${adminPrefix}/PropertySettings/${propertyId}?key=${encodeURIComponent(settingKey)}`,
      null
    );
    return response;
  },
  superAdminOptInAsync: async (request: ISuperAdminOptInRequest) => {
    const response = await postDataAsync<ISuperAdminOptInResponse>(
      `${adminPrefix}/SuperAdmin/OptIn`,
      request
    );
    return response;
  },
};
